import { render } from "./Cancel.vue?vue&type=template&id=47a5b006"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__